import React from 'react';

const ExclamationInCircleSvg = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15 9.375V15.9375"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 21.5625C15.7767 21.5625 16.4062 20.9329 16.4062 20.1562C16.4062 19.3796 15.7767 18.75 15 18.75C14.2233 18.75 13.5938 19.3796 13.5938 20.1562C13.5938 20.9329 14.2233 21.5625 15 21.5625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ExclamationInCircleSvgV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11.9997 21.9993C17.5223 21.9993 21.9993 17.5223 21.9993 11.9997C21.9993 6.47701 17.5223 2 11.9997 2C6.47701 2 2 6.47701 2 11.9997C2 17.5223 6.47701 21.9993 11.9997 21.9993Z" stroke="currentColor" strokeWidth="1.53841" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 15.9999V12" stroke="currentColor" strokeWidth="1.53841" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 8.00195H12.0112" stroke="currentColor" strokeWidth="1.53841" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ExclamationInCircleSvg;
